<template>
    <div class="email-subject-input">
        <label for="subject-input" class="typographies-paragraph-medium-regular" :class="classes">
            {{ $l10n.__('Objet') }}
        </label>
        <input
            id="subject-input"
            class="typographies-paragraph-medium-regular"
            type="text"
            maxlength="250"
            :value="subject"
            @input="$emit('update:subject', $event.target.value)"
        />
    </div>
</template>
<script>
export default {
    props: {
        subject: {
            type: String,
            required: true,
        },
    },
    computed: {
        classes() {
            return [this.subject.trim().length > 0 ? 'is-active' : ''];
        },
    },
};
</script>

<style scoped lang="scss">
.email-subject-input {
    align-items: center;
    border-bottom: 1px solid var(--colors-common-border-lighter);
    display: flex;
    gap: var(--spacing-1);
    padding: 6px 0;

    &:has(input:focus) {
        border-color: var(--colors-common-border-focus);
        label {
            font-weight: var(--font-weights-proxima-nova-0);
            color: var(--colors-common-text-standard-default);
        }
    }

    label {
        user-select: none;
        color: var(--colors-common-text-standard-placeholder);
        &.is-active {
            font-weight: var(--font-weights-proxima-nova-0);
            color: var(--colors-common-text-standard-default);
        }
    }
    input {
        border: none !important;
        flex-grow: 1;
        padding: 0 !important;
        text-overflow: ellipsis;
    }
}
</style>
